import { Methods, makeCall } from "utils/makeCall";
import { GetWheelStateError, WheelSpinError } from "./luckyWheel.error";

export enum WheelState {
  INACTIVE = 0,
  FESTIVAL = 1,
  WHEEL = 2,
}

type GetWheelStateRequest = void;
type GetWheelStateResponse = WheelState;

export const GetWheelState = makeCall<
  GetWheelStateRequest,
  GetWheelStateResponse,
  GetWheelStateError
>(Methods.GetWheelState);

export enum PrizeType {
  PrizeTypeEmpty = 0,
  PrizeTypeBonus20 = 1,
  PrizeTypeFreeCredit1M = 2,
  PrizeTypeFreeAdView400K = 3,
  PrizeTypeBuyPackage5M = 4,
}

export const PrizeTypeToString = (prize: PrizeType) => {
  switch (prize) {
    case PrizeType.PrizeTypeBonus20:
      return "کد تخفیف 20 درصدی";
    case PrizeType.PrizeTypeFreeCredit1M:
      return "اعتبار تبلیغ";
    case PrizeType.PrizeTypeFreeAdView400K:
      return "تبلیغ رایگان";
    case PrizeType.PrizeTypeBuyPackage5M:
      return "بسته کمپین 5 میلیونی";
    default:
      return "پوچ";
  }
};

export const PrizeTypeToText = {
  [PrizeType.PrizeTypeEmpty]: "بد آوردی! پوچه! ☹️",
  [PrizeType.PrizeTypeBonus20]: "کد تخفیف 20 درصدی تبلیغات تب گفتگو برنده شدی!🫡",
  [PrizeType.PrizeTypeFreeCredit1M]: "مبارکه! یک میلیون اعتبار تبلیغ تقدیم به شما!🎁",
  [PrizeType.PrizeTypeFreeAdView400K]: "یه تبلیغ با 400 هزار بازدید مهمون مایی!🫶 ",
  [PrizeType.PrizeTypeBuyPackage5M]: [
    "تا حالا شده بخوای بستهٔ VIP بخری ولی جمع و جورتر⁉️",
    "تبریک!🎁 امکان خرید این بسته برات فعال شد🫶",
  ],
};

type WheelSpinRequest = void;
type WheelSpinResponse = PrizeType;

export const WheelSpin = makeCall<WheelSpinRequest, WheelSpinResponse, WheelSpinError>(
  Methods.WheelSpin
);
